var map = {
	"./search-filters_19.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/search-filters_19.cjs.entry.js",
	"./vviinn-button_2.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-button_2.cjs.entry.js",
	"./vviinn-carousel_8.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-carousel_8.cjs.entry.js",
	"./vviinn-error.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-error.cjs.entry.js",
	"./vviinn-preloader.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-preloader.cjs.entry.js",
	"./vviinn-selected-filters.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-selected-filters.cjs.entry.js",
	"./vviinn-vps-button.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-vps-button.cjs.entry.js",
	"./vviinn-vps-widget.cjs.entry.js": "./node_modules/vviinn-widgets/dist/cjs/vviinn-vps-widget.cjs.entry.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./node_modules/vviinn-widgets/dist/cjs sync recursive ^\\.\\/.*\\.entry\\.js$";